export const DELETE_CONFIRMATION_TEXT = "Delete";

export function isDeleteConfirmation(value: string): boolean {
  return value === DELETE_CONFIRMATION_TEXT;
}

export function DeleteConfirmationField({ value, onChange, autoFocus = true }: { value: string; onChange: (value: string) => void; autoFocus?: boolean }) {
  return <label className="delete-confirmation-field">
    <span>To confirm, manually type <strong className="delete-confirmation-token" aria-label={DELETE_CONFIRMATION_TEXT} onCopy={(event) => event.preventDefault()}>{DELETE_CONFIRMATION_TEXT}</strong></span>
    <input
      autoFocus={autoFocus}
      aria-label="Type Delete to confirm"
      autoComplete="off"
      autoCapitalize="off"
      spellCheck={false}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      onPaste={(event) => event.preventDefault()}
      onDrop={(event) => event.preventDefault()}
      placeholder="Type Delete"
    />
    <small>Pasting and dropping text are disabled for this confirmation.</small>
  </label>;
}
